import React from 'react';
import Meta from '../../components/Meta';
import NewChangeRequestInput from '../../components/ChangeRequest/NewChangeRequestInput/NewChangeRequestInput';
import './NewChangeRequestScreen.less';

const NewChangeRequestScreen: React.FC = () => {
  return (
    <>
      <Meta name="Cirra AI - Change Request Detail" />
      <div id="create-change-request" data-testid="create-change-request">
        <NewChangeRequestInput />
      </div>
    </>
  );
};

export default NewChangeRequestScreen;
